import * as React from "react";
const usePreviousValue = (value) => {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
export {
  usePreviousValue
};
//# sourceMappingURL=usePreviousValue.js.map
